import Vue from 'vue';
import i18n from '@/lang'
//import store from '@/store'
import SimpleVueValidation from 'simple-vue-validator'
let Validator
if(i18n.locale=='ru'){
  Validator = SimpleVueValidation.Validator.create({templates: {
  
  mustBeFloat: 'Должно быть числом',
  mustBeInteger: 'Должно быть целым числом',
  mustBeNumber: 'Должно быть числом.',
  mustLessThan: 'Должно быть меньше {0}.',
  mustLessThanOrEqualTo: 'Должно быть меньше или равно {0}.',
  mustGreaterThan: 'Должно быть больше, чем {0}.',
  mustGreaterThanOrEqualTo: 'Должно быть больше или равно {0}.',
  mustBetween: 'Должно быть между {0} и {1}.',
  sizeMustBe: 'Размер должен быть {0}.',
  lengthMustBe: 'Длина должна быть {0}.',
  lengthAtLeast: 'Должно содержать как минимум {0} символов.',
  lengthAtMost: 'Должно быть не более {0} символов.',
  lengthMustBetween: 'Длина должна быть между {0} и {1}.',
  valueMustIn: 'Должно быть {0}.',
  valueMustNotIn: 'Не должно быть {0}.',
  valueNotMatch: 'Не найдено.',
  regexInvalid: 'Неверный формат.',
  digitInvalid: 'Должен быть цифрой',
  emailInvalid: 'Неверный адрес электронной почты.',
  urlInvalid: 'Неверный URL.',
  float: 'Должно быть число',
  integer: 'Должно быть целым числом',
  number: 'Должен быть номер',
  lessThan: 'Должно быть меньше {0}',
  lessThanOrEqualTo: 'Должно быть меньше или равно {0}.',
  moreThan: 'Должно быть больше, чем {0}',
  moreThanOrEqualTo: 'Должно быть больше или равно {0}.',
  between : 'Должно быть между {0} и {1}.',
  size: 'Размер должен быть {0}.',
  length: 'Длина должна быть {0}.',
  minLength: 'Должно быть не менее {0} символов',
  maxLength: 'Должно быть не более {0} символов',
  lengthBetween: 'Длина должна быть между {0} и {1}.',
  in: 'Должно быть {0}',
  notIn: 'Не должно быть {0}',
  match: 'не совпало',
  regex: 'Неверный формат.',
  digit: 'Должна быть цифрой',
  email: 'Неверный адрес электронной почты',
  url: 'Неверный URL.',
  required: 'Это поле обязательно для заполнения.'
  }});
}else{
     Validator = SimpleVueValidation.Validator.create()
}
  Vue.use(SimpleVueValidation)
  export default Validator
  export const error_setter = {
      methods: {
        add_external_errors: function(errors){ 
            const fields = this.validation.passedRecords.map(function(record) {
                return record.field
            });  
                for (var key in errors) {

                    if(fields.includes(key)){
                        this.validation.setError(key, this.$t('message.'+errors[key].toString().toLowerCase()))
                    }else{
                        this.$store.dispatch('set_alert',{type:'danger', text:this.$t('message.send_exception')})
                        console.log ('not_found error field in field list '+key)  
                        return false;
                    }
                }
            
        },
    }
  }


